import React from 'react'
import { useContext } from 'react'
import { Route, Link, Switch, useLocation, useRouteMatch} from 'react-router-dom'
import fairLogo from '../images/FAIR_logo_RGB.png';
import BAlogo from '../images/BA-ENG-RGB.png';
import RISElogo from '../images/RISE_BLACK.png';

const About = () => {
 
  



  return (
    <div ID="about-page" className="content">
        <div className="content-wrap about-content">
            <div className="about-box">
              <h2>About Volta and the Fair project</h2>
              <p>The Volta prototype is the booking website of an imaginary future electric airline servicing the Kvarken region, speculating on the user-experience of <br/>on-demand regional aviation. Three key features set this system apart from air travel as we know it. There is no schedule, pricing directly reflects flexibility and travel is booked from address to address. The aim of Volta is to make a possible new form of future travel experienceable, in order raise discussion on what is desired.

</p>
            </div>

            <div className="about-box">
              {/* <h2>Partners</h2>
              <p>The Fair project is a collaboration between </p> */}
              <div className="logos">
                  <div id="fair-logo" className="logo-wrap">
                   <img src={fairLogo} alt="Fair-logo" />
                  </div>
                  <div id="ba-logo" className="logo-wrap">
                    <img src={BAlogo} alt="BA-logo" />
                  </div>
                  <div id="rise-logo" className="logo-wrap">
                    <img src={RISElogo} alt="RISE-logo" />
                  </div>
              </div>
            </div>


        </div>
       
    </div>
  )
}

export default About
